import React from 'react';
import ExpensesComponent  from '../components/Expenses';
import { Row, Col, Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

const Expenses = () => {
  
  return (
    <div className="content-wrapper">
      <h3>Despesas</h3>
        <Breadcrumb style={{ marginBottom: 16 }}>
          <Breadcrumb.Item>
            <Link to="/">Início</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Despesas</Breadcrumb.Item>
        </Breadcrumb>
      <Row>
        <Col
          xs={0} // Esconde em dispositivos pequenos
          sm={0} // Esconde em dispositivos médios
          md={24} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <ExpensesComponent />
        </Col>
        <Col
          xs={24} // Esconde em dispositivos pequenos
          sm={24} // Esconde em dispositivos mdios
          md={0} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <ExpensesComponent />
        </Col>
      </Row>
    </div>
  );
};

export default Expenses;